import { render, staticRenderFns } from "./ProductCommonInfo.vue?vue&type=template&id=0bf82649&scoped=true"
import script from "./ProductCommonInfo.vue?vue&type=script&lang=js"
export * from "./ProductCommonInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductCommonInfo.vue?vue&type=style&index=0&id=0bf82649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf82649",
  null
  
)

export default component.exports